import React, { FC } from 'react'
import { IndustryRecognitionProps } from './IndustryRecognition.types'
import { sanitizeHTML } from '../../utils/common-utils'
import { ImageCompound } from '@ampdx/component-library/src/components/Compounds/src/ImageCompound'
import './IndustryRecognition.scss'
import { getValueListBgColor } from '@ampdx/component-library/src/utils'

export const IndustryRecognition: FC<IndustryRecognitionProps> = props => {
  const {
    heading,
    subHeading,
    firstImage,
    secondImage,
    thirdImage,
    fourthImage,
    fifthImage,
    sixthImage,
    seventhImage,
    eigthImage,
    bgColor,
    linkText,
    linkDisclosure,
  } = props.content

  const scrollToSection = (path: string) => {
    const section = document.getElementById(path)
    section?.scrollIntoView({ behavior: 'smooth' })
  }
  return (
    <section className={`IndustryRecognition--page ${getValueListBgColor(bgColor ?? '')}`}>
      <div className='u-sizeConstrained'>
        <div
          className='IndustryRecognition--mainHeading'
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(heading) }}></div>
        <div
          className='IndustryRecognition--subHeading'
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(subHeading) }}></div>
        <div className='IndustryRecognition-ParentFlex u-flex u-flexCol'>
          <div className='IndustryRecognition-firstRow u-flex u-md-flexCol u-sm-flexCol u-md-sizeFull u-sm-sizeFull'>
            <div className='IndustryRecognition--RectImage'>
              <ImageCompound {...firstImage} />
            </div>
            <div className='IndustryRecognition--RectImage'>
              <ImageCompound {...secondImage} />
            </div>
            <div className='IndustryRecognition--RectImage'>
              <ImageCompound {...thirdImage} />
            </div>
          </div>
          <div className='IndustryRecognition-secondRow u-flex u-sizeConstrained u-md-flexCol u-sm-flexCol u-md-sizeFull u-sm-sizeFull'>
            <div className='IndustryRecognition--RectImage'>
              <ImageCompound {...fourthImage} />
            </div>
            <div className='IndustryRecognition--LongImage'>
              <ImageCompound {...fifthImage} />
            </div>
          </div>
          <div className='IndustryRecognition-thirdRow u-flex u-md-flexCol u-sm-flexCol u-md-sizeFull u-sm-sizeFull'>
            <div className='IndustryRecognition--RectImage'>
              <ImageCompound {...sixthImage} />
            </div>
            <div className='IndustryRecognition--LongImage'>
              <ImageCompound {...seventhImage} />
            </div>
            <div className='IndustryRecognition--RectImage'>
              <ImageCompound {...eigthImage} />
            </div>
          </div>
        </div>
        <div className='Disclaimer-text IndustryRecognition--disclosureFlex u-flex u-flexJustifyEnd u-paddingRight48'>
          <a
            className='IndustryRecognition--disclosureLink'
            href={'#' + linkDisclosure}
            onClick={e => {
              e.preventDefault()
              scrollToSection(linkDisclosure ?? '')
            }}>
            {linkText}
          </a>
        </div>
      </div>
    </section>
  )
}
